<style lang="stylus" scope>
    .mask
        position fixed
        top 0
        left 0
        bottom 0
        right 0
        background rgba(0, 0, 0, 0.3)
        z-index 100

        .shadow-box
            width 400px
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
            border-radius 5px
            border 1px solid #d2d2d2
            background #FFF
            z-index 9
            padding 20px 40px 30px 40px
            user-select none

            .sa-title
                font-size 20px
                margin-bottom 25px
                font-weight lighter

            .sa-close
                position absolute
                font-size 18px
                top 28px
                right 40px
                width 15px
                height 15px
                user-select none

                svg
                    display block
                    width 14px
                    height 14px
                    //fill currentColor
                    transition all 0.15s

                    &:hover
                        fill #de5145

            .sa-type
                width 100%
                display flex
                justify-content space-between

                .sa-item
                    text-align center
                    cursor pointer
                    transition all 0.15s ease-in-out
                    margin-bottom 25px
                    color #bfbfbf

                    svg
                        display block
                        margin 0 auto
                        width 40px
                        height 40px
                        fill currentColor
                        transition all 0.15s
                        margin-bottom 5px
                        //color #bfbfbf

                    &:hover
                        color #638bfc

                .sa-check
                    color #638bfc

                input
                    display none

            .sa-btn
                display block
                float right
                border none
                outline none
                width 60px
                height 25px
                text-align center
                color #fff
                background #3788e3
                cursor pointer
                border-radius 3px
    .math-saveas-modal
        width 400px
        height 200px
        .math-saveas-container
            padding 20px
            .math-saveas-type
                display flex
                justify-content space-between
                .sa-item
                    text-align center
                    cursor pointer
                    transition all 0.15s ease-in-out
                    color #bfbfbf
                    p
                        color #bfbfbf
                    svg
                        display block
                        margin 0 auto
                        width 40px
                        height 40px
                        fill #bfbfbf
                        transition all 0.15s
                        margin-bottom 5px
                    &:hover
                        color #638bfc
                        p
                            color #638bfc
                .sa-check
                    color #638bfc
                    p
                        color #638bfc
                    svg
                        fill #638bfc
            input
                display none
</style>

<template>
    <div class="math-dialog-mask">
        <Dialog class="math-saveas-modal" @close="closeWin" :extra="true" :title="$t('saveAs_title')" :contentWidth="400" :contentHeight="200">
            <div class="math-saveas-container">
                <div class="math-saveas-type">
                    <label for="math-save-img" class="sa-item" :class="{ 'sa-check': type == 'img' }">
                        <iconSymbol name="math-save-img"></iconSymbol>
                        <p>{{ $t("saveAs_img") }}</p>
                    </label>
                    <label for="math-save-mml" class="sa-item" :class="{ 'sa-check': type == 'mml' }">
                        <iconSymbol name="math-save-mml"></iconSymbol>
                        <p>{{ $t("saveAs_mml") }}</p>
                    </label>
                    <label for="math-save-tex" class="sa-item" :class="{ 'sa-check': type == 'tex' }">
                        <iconSymbol name="math-save-tex"></iconSymbol>
                        <p>{{ $t("saveAs_latex") }}</p>
                    </label>
                </div>
                <input type="radio" name="type" id="math-save-img" value="img" v-model="type" />
                <input type="radio" name="type" id="math-save-mml" value="mml" v-model="type" />
                <input type="radio" name="type" id="math-save-tex" value="tex" v-model="type" />
            </div>
            <div class="dialog-btnbox-normal">
                <div class="dialog-btn-ok" @click="saveFile">{{ $t("confirm") }}</div>
                <div class="" @click="closeWin">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
        <!-- <Modal // 暂时注释没vip限制。
            v-model="tipsShow"
            width="300"
            title="提示">
            <p>购买vip后解锁保存图片功能</p>
        </Modal> -->
    </div>
</template>

<script>
    import Dialog from "@/app/components/Modals/Dialog.vue";
    export default {
        name: "",
        components: { Dialog },
        inject: ["EDMathUI"],
        data() {
            return {
                type: "img",
                tipsShow: false,
            };
        },
        computed: {
            nolimit() {
                return this.$store.state.ui.nolimitMath;
            },
        },
        methods: {
            saveFile() {
                // 保存格式选择
                switch (this.type) {
                    case "img": {
                        if (!this.$store.state.isVip && !this.nolimit) {
                            this.tipsShow = true;
                            return;
                        }
                        if (null != this.EDMathUI.view) {
                            this.EDMathUI.view.outputPng("EdrawMath");
                        }
                        break;
                    }
                    case "mml": {
                        this.type = "img";
                        if (null != this.EDMathUI.view) {
                            var mml = this.EDMathUI.view.outputMml();
                            var blob = new Blob([mml]);
                            saveAs(blob, "MML.mml");
                        }
                        break;
                    }
                    case "tex": {
                        this.type = "img";
                        if (null != this.EDMathUI.view) {
                            var latex = this.EDMathUI.view.outputLatex();
                            var blob = new Blob([latex]);
                            let a = saveAs(blob, "LATEX.latex");
                        }
                        break;
                    }
                }
                this.type = "img";
                this.$emit("setSave", false);
            },
            // 关闭保存窗口
            closeWin() {
                this.type = "img";
                this.$emit("setSave", false);
                this.EDMathUI.view.focus();
            },
        },
    };
</script>
<i18n>
{
  "zh": {
    "saveAs_title": "另存为",
    "saveAs_img": "图片",
    "saveAs_mml": "mml文件",
    "saveAs_latex": "latex文件",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "saveAs_title": "Save as",
    "saveAs_img": "picture",
    "saveAs_mml": "mml File",
    "saveAs_latex": "latex File",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "fr": {
    "saveAs_title": "Sauvegarder comme",
    "saveAs_img": "Image",
    "saveAs_mml": "Fichier mml",
    "saveAs_latex": "Fichier latex",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "saveAs_title": "Speichern als",
    "saveAs_img": "Bild",
    "saveAs_mml": "mml-Datei",
    "saveAs_latex": "Latex-Datei",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "jp": {
    "saveAs_title": "名前を付けて保存",
    "saveAs_img": "画像",
    "saveAs_mml": "mmlファイル",
    "saveAs_latex": "latexファイル",
    "confirm": "OK",
    "cancel": "キャンセル"
  },
  "es": {
    "saveAs_title": "Guardar como",
    "saveAs_img": "Picture",
    "saveAs_mml": "Archivo mml",
    "saveAs_latex": "Archivo de látex",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "pt": {
    "saveAs_title": "Gravar Como",
    "saveAs_img": "imagem",
    "saveAs_mml": "Ficheiro mml",
    "saveAs_latex": "Ficheiro latex",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "saveAs_title": "Salva Come",
    "saveAs_img": "Immagine",
    "saveAs_mml": "File MML",
    "saveAs_latex": "File LaTex",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "saveAs_title": "另存新檔",
    "saveAs_img": "圖片",
    "saveAs_mml": "mml檔案",
    "saveAs_latex": "latex檔案",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "saveAs_title": "다른 이름으로 저장",
    "saveAs_img": "그림",
    "saveAs_mml": "mml파일 ",
    "saveAs_latex": "latex파일 ",
    "confirm": "확인 ",
    "cancel": "취소 "
  }
}
</i18n>
